import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { CLIENT_UPDATE_TAP_EVENT, consumeClientUpdateTap } from '../../lib/clientPush';
import { inAppPath } from '../../lib/inAppPath';

/** The screens a client's update opens (`clientPush.js` builds only these). */
const UPDATE_SCREENS = ['/live-tracking', '/notifications'];

/**
 * Opens the delivery a client tapped an update for (`clientPush.js`):
 * one parked by a cold start, and any that arrives while the app runs.
 * Mounted once under the router; draws nothing.
 *
 * Both arrive through places any script on the page can write (session
 * storage, a window event), so only an update's own screens are opened
 * (`inAppPath`; ingo-39's router audit, 5 Oct 2026).
 */
export default function ClientUpdateTaps() {
  const navigate = useNavigate();

  useEffect(() => {
    const open = (link) => {
      const to = inAppPath(link, UPDATE_SCREENS);
      if (to) navigate(to);
      else if (link) console.warn(`[clientPush] a tap's link is not an update's screen, ignored ${JSON.stringify({ link: String(link).slice(0, 80) })}`);
    };

    open(consumeClientUpdateTap());

    const onTap = (e) => {
      consumeClientUpdateTap();
      open(e?.detail?.link);
    };
    window.addEventListener(CLIENT_UPDATE_TAP_EVENT, onTap);

    return () => window.removeEventListener(CLIENT_UPDATE_TAP_EVENT, onTap);
  }, [navigate]);

  return null;
}
